<img [src]="image" />
<ng-content></ng-content>